import { RotateCcw } from "lucide-react";
import { useTranslation } from "react-i18next";

/** Full-screen hint shown only in portrait (CSS media query) — the register is landscape-only. */
export function PortraitHint() {
  const { t } = useTranslation();
  return (
    <div
      role="dialog"
      aria-labelledby="rotate-title"
      className="fixed inset-0 z-[60] hidden flex-col items-center justify-center gap-4 bg-background p-8 text-center portrait:flex"
    >
      <RotateCcw className="size-12" aria-hidden />
      <h1 id="rotate-title" className="text-2xl">
        {t("rotate.title")}
      </h1>
      <p className="text-muted-foreground">{t("rotate.body")}</p>
    </div>
  );
}
